export const DATE_TIME_FORMAT = 'YYYY-MM-DD H:mm:00'; // seconds always need to be 00 for correct range comparison
export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'H:mm:00';
export const TABLET_WIDTH = 768;
export const DEFAULT_TIME_ZONE = 'America/Chicago';
export const SYNC_INTERVAL = 30;
